<div [formGroup]="form" class="tax-fields-container">
  <h5 class="title">Tax identifiers</h5>
  <div class="settings-row is-active-row">
    <span class="is-active-txt">Auto-map tax IDs to shipments</span>
    <pdq-slide-toggle
      formControlName="isTaxIDsAutoApplyActive"
      [defaultValue]="isTaxIDsAutoApplyActive"></pdq-slide-toggle>
  </div>
  @for (field of fields; track field) {
    <div>
      @if (!field?.hidden) {
        <div class="row">
          @if (field.type === FieldType.INPUT) {
            <pdq-input
              formControlName="{{ field.name }}"
              name="{{ field.name }}"
              [label]="field.label"
              [placeholder]="field.placeholder"
              variant="form"
              [invalid]="isControlInvalid(field.name)"
              [invalidMsg]="field.validationMsg"
              autocomplete="off"></pdq-input>
          }
          @if (field.type == FieldType.RADIO) {
            <pdq-radio-group
              formControlName="{{ field.name }}"
              [label]="field.label"
              [tooltip]="field.tooltip"
              [value]="field.default">
              @for (option of field.options; track option) {
                <pdq-radio-button
                  [text]="option.label"
                  [value]="option.value"
                  [checked]="option.value === form.value.customDeclarationCalculatedBy"></pdq-radio-button>
              }
            </pdq-radio-group>
          }
        </div>
      }
    </div>
  }
  <div class="row">Additional tax IDs</div>
  @if (form.controls['VAT_IDS']?.value?.length) {
    <table class="additional-tax-ids">
      <tr>
        <th>Type</th>
        <th>Issuing authority</th>
        <th>Number</th>
        <th>Nickname</th>
        <th>Description</th>
        <th></th>
      </tr>
      @for (taxField of form.controls['VAT_IDS']?.value; track taxField) {
        <tr>
          <td>{{ taxField.type }}</td>
          <td>{{ getCountryNameByCode(taxField.country) }}</td>
          <td>{{ replaceWithAsterisk(taxField.taxId) }}</td>
          <td>{{ taxField.nick }}</td>
          <td [title]="taxField.description || ''">{{ taxField.description }}</td>
          <td><span (click)="deleteTaxId(taxField.taxId)" class="action-btn">Delete</span></td>
        </tr>
      }
    </table>
  }

  <div class="row">
    <span (click)="openAddTaxIDWindow()" class="add-tax-btn">+Add tax ID</span>
  </div>
</div>
